import React from "react";
import "./HeroCarousel.css";
import FrameBg from "./Assets/Frame.png";

function HeroCarousel() {
  const items = [
    {
      quote:
        "It's easier to hold your principles 100% of the time than it is to hold them 98% of the time.",
      author: "Clay Christinsen",
    },
    {
      quote: "The best way to predict the future is to create it.",
      author: "Peter Drucker",
    },
    {
      quote:
        "Great things in business are never done by one person, they are done by a team of people.",
      author: "Steve Jobs",
    },
    {
      quote: "The Only way to do great work is to love what you do",
      author: "Steve Jobs",
    },
  ];

  return (
    <div className="hero-wrapper">
      <p className="hero-main-title">
        {/* Our philosophy-{" "} */}
        <span className="hero-sub-title">
          “Innovation is optimistic lifestyle.”
        </span>
      </p>

      <h2 className="hero-title">Our heros</h2>
      <p className="hero-description">From the minds that shaped history</p>

      <div className="carousel-row">
        {items.map((item, index) => (
          <div
            className="carousel-card"
            key={index}
            style={{ backgroundImage: `url(${FrameBg})` }}
          >
            <p className="carousel-quote">{item.quote}</p>
            <p className="carousel-author">– {item.author}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HeroCarousel;
